import { type ForwardedRef, forwardRef, type KeyboardEvent } from 'react';

import keymap from '@/utils/keymap';

import S from './styled';
import type { TitleInputT } from './types';

const TitleInput = (
  props: TitleInputT,
  ref: ForwardedRef<HTMLInputElement>,
) => {
  const { sizeType = 'm', style, css, ...rest } = props;

  const handleInputKeydown = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (e.nativeEvent.isComposing) return;
    if (keymap.isEscape(e) || keymap.isEnter(e)) {
      (document.activeElement as HTMLElement).blur();
    }
    props.onKeyDown?.(e);
  };

  return (
    <S.StyledInputWrapper
      {...rest}
      css={css}
      sizeType={sizeType}
      style={{ ...style }}
      onKeyDown={(e) => {
        props.onKeyDown?.(e);
        handleInputKeydown(e);
      }}
      ref={ref}
    ></S.StyledInputWrapper>
  );
};

export default forwardRef(TitleInput);
